












































import Vue from 'vue';
import Scrobble from '@/models/Scrobble';
import SpotifyListen from '@/models/SpotifyListen';

export default Vue.extend({
  data() {
    return {
      pagination: {
        sortBy: 'time',
        rowsPerPage: 25,
      },
      search: '',
      selectedTracks: [],
      headers: [
        {
          text: 'Track title',
          value: 'track',
        },
        {
          text: 'Artist',
          value: 'artist',
        },
        {
          text: 'Date',
          value: 'time',
        },
      ],
    };
  },
  computed: {
    allScrobbleableTracks(): any[] {
      return this.$store.state.validScrobbles.map((scrob: SpotifyListen, i: number) => {
        return {
          value: false,
          id: i,
          track: scrob.trackName,
          artist: scrob.artistName,
          time: scrob.listenDate.getTime(),
        };
      });
    },
  },
  methods: {
    prettyDate(date: Date) {
      return date.toString();
    },
    scrobbleSelectedTracks() {
      this.commitTracksToStore(this.selectedTracks);
      this.$emit('complete');
    },
    scrobbleAllTracks() {
      this.commitTracksToStore(this.allScrobbleableTracks);
      this.$emit('complete');
    },
    commitTracksToStore(tracks: any[]) {
      this.$store.commit('setSelectedScrobbles', tracks.map((track: any) => {
        return new Scrobble(track.track, track.artist, new Date(track.time));
      }));
    },
  },
});
